import React, { FC } from "react";
import cn from "classnames";
import { IProperty } from "./types";

interface Props extends IProperty {
  className?: string;
}

export const Property: FC<Props> = ({ className, label, value, icon }) => {
  const combinedClassNames = cn(
    className,
    "flex justify-between items-center gap-3 py-3 gl:text-lg font-medium capitalize"
  );

  return (
    <p className={combinedClassNames}>
      <span className="flex gap-2.5 text-purple-base">
        {icon && (
          <img className="w-6 aspect-square" src={icon.url} alt={icon.title} />
        )}
        <span>{label}</span>
      </span>
      <span>{value}</span>
    </p>
  );
};
